import React, { useMemo } from "react";
import "./style.css";
import {TargetBodyType} from "./TargetBodyType";
import { useImagePreloader } from "../../../../hooks/useImagePreloader";

export const TargetBodyTypeHook = (props) => {
  const { data } = props;
  
  // Define image options to match Image component defaults
  const imageOptions = {
    quality: 100,
    formatSize: 1
  };
  
  // Check if gender is selected
  const hasGender = data.gender === 'male' || data.gender === 'female';
  
  // Use useMemo to cache the image list to avoid unnecessary recalculation
  const bodyTypeList = useMemo(() => {
    // Return empty array if gender is not selected yet
    if (!hasGender) {
      return [];
    }
    
    if (data.gender === 'male') {
      return [{
        image: "/static/image/questionnaire/fasting/targetBodyType/male_cut.png" ,
        value: "cut",
        title: "Cut",
      },{
        image: "/static/image/questionnaire/fasting/targetBodyType/male_bulk.png",
        value: "bulk",
        title: "Bulk",
      },{
        image: "/static/image/questionnaire/fasting/targetBodyType/male_extra_bulk.png",
        value: "extra_bulk",
        title: "Extra Bulk",
      }]
    } else {
      return [{
        image: "/static/image/questionnaire/fasting/targetBodyType/female_fit.png",
        value: "fit",
        title: "Fit",
      },{
        image: "/static/image/questionnaire/fasting/targetBodyType/female_muscular.png",
        value: "muscular",
        title: "Muscular",
      },{
        image: "/static/image/questionnaire/fasting/targetBodyType/female_shapely.png",
        value: "shapely",
        title: "Shapely",
      }]
    }
  }, [data.gender, hasGender]);

  // Extract image URLs for preloading
  const imageUrls = useMemo(() => {
    return bodyTypeList.map(item => item.image);
  }, [bodyTypeList]);

  // Use image preload hook, only enable when gender is selected
  const { isAllLoaded, loadingImages } = useImagePreloader(imageUrls, hasGender, imageOptions);

  const getList = () => bodyTypeList;
  
  // Don't render if gender is not selected (avoid showing wrong gender images)
  if (!hasGender) {
    return null;
  }

  return (
      <TargetBodyType
          {...props}
          getList={getList}
          isImagesLoaded={isAllLoaded}
          loadingImages={loadingImages}
      />
  );
};
